import React, { Component } from 'react'
import { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { Dialog, Transition } from '@headlessui/react'
import { UserAddIcon, XIcon, CheckCircleIcon, ExclamationCircleIcon, HomeIcon } from '@heroicons/react/outline'
import connexion from '../../connexion'
import { parseDate } from '../../tools'
import tools from '../../tools'
import Loader from '../UI/Loader'
import ModalDelete from '../UI/ModalDelete'
import './DashboardUsers.css'

class DashboardUsers extends Component
{
	constructor(props)
	{
		super(props)
		this.state = {
			users: null,
			error: null,
			modal_open: false,
			modal_mode: 'create',
			edit_user_id: null,
			modal_delete: false,
			delete_user_id: null,
			editing_team: null,
			modal_permissions: false,
			permissions_user_id: null,
			permissions_form: {},
			attempt_permissions: false,
			attempt_submit: false,
			attempt_delete: false,
			form_error: null,
			toast: null,
			form: {
				avatar: null,
				avatar_preview: null,
				lastname: '',
				firstname: '',
				email: '',
				username: '',
				password: '',
				confirm: ''
			}
		}
		this.props.updateNavbarTitle('Équipe & accès')
	}

	componentDidMount()
	{
		this.loadUsers()
	}

	loadUsers = () =>
	{
		fetch(connexion.connect.url + 'dashboard/users/list')
			.then(res => res.json())
			.then(users =>
			{
				this.setState({ users: users })
			})
			.catch(err =>
			{
				console.log(err)
				this.setState({ error: 'Impossible de charger les utilisateurs.' })
			})
	}

	showToast = (message, type = 'success') =>
	{
		this.setState({ toast: { message, type } })
		clearTimeout(this._toastTimer)
		this._toastTimer = setTimeout(() => this.setState({ toast: null }), 4000)
	}

	openCreateModal = () =>
	{
		this.setState({
			modal_open: true,
			modal_mode: 'create',
			edit_user_id: null,
			form_error: null,
			form: {
				avatar: null,
				avatar_preview: null,
				lastname: '',
				firstname: '',
				email: '',
				username: '',
				password: '',
				confirm: ''
			}
		})
	}

	openEditModal = (user) =>
	{
		this.setState({
			modal_open: true,
			modal_mode: 'edit',
			edit_user_id: user._id,
			form_error: null,
			form: {
				avatar: null,
				avatar_preview: user.avatar || null,
				lastname: user.lastname || '',
				firstname: user.firstname || '',
				email: user.email || '',
				username: user.username || '',
				password: '',
				confirm: ''
			}
		})
	}

	closeModal = () =>
	{
		if (this.state.attempt_submit)
			return
		this.setState({ modal_open: false })
	}

	openDeleteModal = (user_id) =>
	{
		this.setState({ modal_delete: true, delete_user_id: user_id })
	}

	answerModalDelete = (answer) =>
	{
		if (!answer)
		{
			this.setState({ modal_delete: false, delete_user_id: null })
			return
		}
		this.setState({ attempt_delete: true })
		fetch(connexion.connect.url + 'dashboard/users/delete', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ id: this.state.delete_user_id })
		})
		.then(res => res.json())
		.then(ret =>
		{
			this.setState({ attempt_delete: false, modal_delete: false, delete_user_id: null })
			if (ret !== false)
			{
				this.showToast('Utilisateur supprimé.')
				this.loadUsers()
			}
			else
				this.showToast('Une erreur s\'est produite lors de la suppression.', 'error')
		})
		.catch(err =>
		{
			console.log(err)
			this.setState({ attempt_delete: false, modal_delete: false, delete_user_id: null })
			this.showToast('Une erreur s\'est produite lors de la suppression.', 'error')
		})
	}

	updateTeam = (user_id, value) =>
	{
		const team = value === '' ? null : value
		fetch(connexion.connect.url + 'dashboard/users/update-team', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ id: user_id, team: team })
		})
		.then(res => res.json())
		.then(ret =>
		{
			this.setState({ editing_team: null })
			if (ret !== false)
			{
				this.showToast(team === null ? 'Équipe réinitialisée.' : 'Équipe mise à jour.')
				this.loadUsers()
			}
			else
				this.showToast('Erreur lors de la mise à jour de l\'équipe.', 'error')
		})
		.catch(err =>
		{
			console.log(err)
			this.setState({ editing_team: null })
			this.showToast('Erreur lors de la mise à jour de l\'équipe.', 'error')
		})
	}

	openPermissionsModal = (user) =>
	{
		this.setState({
			modal_permissions: true,
			permissions_user_id: user._id,
			permissions_form: { ...user.permissions }
		})
	}

	closePermissionsModal = () =>
	{
		if (this.state.attempt_permissions)
			return
		this.setState({ modal_permissions: false, permissions_user_id: null, permissions_form: {} })
	}

	handlePermissionChange = (key, value) =>
	{
		this.setState({
			permissions_form: {
				...this.state.permissions_form,
				[key]: value
			}
		})
	}

	submitPermissions = () =>
	{
		this.setState({ attempt_permissions: true })
		fetch(connexion.connect.url + 'dashboard/users/update-permissions', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				id: this.state.permissions_user_id,
				permissions: this.state.permissions_form
			})
		})
		.then(res => res.json())
		.then(ret =>
		{
			this.setState({ attempt_permissions: false, modal_permissions: false, permissions_user_id: null, permissions_form: {} })
			if (ret !== false)
			{
				this.showToast('Permissions mises à jour.')
				this.loadUsers()
			}
			else
				this.showToast('Une erreur s\'est produite lors de la mise à jour.', 'error')
		})
		.catch(err =>
		{
			console.log(err)
			this.setState({ attempt_permissions: false })
			this.showToast('Une erreur s\'est produite lors de la mise à jour.', 'error')
		})
	}

	handleAvatar = (event) =>
	{
		const file = event.target.files[0]
		if (!file)
			return
		const reader = new FileReader()
		reader.addEventListener('load', () =>
		{
			this.setState({
				form: {
					...this.state.form,
					avatar: reader.result,
					avatar_preview: reader.result
				}
			})
		}, false)
		reader.readAsDataURL(file)
	}

	handleField = (key, event) =>
	{
		this.setState({
			form: {
				...this.state.form,
				[key]: event.target.value
			}
		})
	}

	handleSubmit = (event) =>
	{
		event.preventDefault()
		const { modal_mode, edit_user_id } = this.state
		const { avatar, lastname, firstname, email, username, password, confirm } = this.state.form
		if (lastname.length === 0)
			return this.setState({ form_error: 'Veuillez indiquer le nom.' })
		if (firstname.length === 0)
			return this.setState({ form_error: 'Veuillez indiquer le prénom.' })
		if (email.length === 0)
			return this.setState({ form_error: 'Veuillez indiquer l\'adresse e-mail.' })
		if (tools.testEmail(email) === false)
			return this.setState({ form_error: 'Adresse e-mail invalide.' })
		if (username.length === 0)
			return this.setState({ form_error: 'Veuillez indiquer le nom d\'utilisateur.' })
		if (username.length < 4)
			return this.setState({ form_error: 'Nom d\'utilisateur trop court (4 caractères min.).' })
		if (modal_mode === 'create')
		{
			if (password.length === 0)
				return this.setState({ form_error: 'Veuillez indiquer le mot de passe.' })
			if (password.length < 8)
				return this.setState({ form_error: 'Mot de passe trop court (8 caractères min.).' })
			if (confirm.length === 0)
				return this.setState({ form_error: 'Veuillez confirmer le mot de passe.' })
			if (password !== confirm)
				return this.setState({ form_error: 'Le mot de passe et sa confirmation sont différents.' })
		}
		else if (password.length > 0)
		{
			if (password.length < 8)
				return this.setState({ form_error: 'Mot de passe trop court (8 caractères min.).' })
			if (password !== confirm)
				return this.setState({ form_error: 'Le mot de passe et sa confirmation sont différents.' })
		}
		this.setState({ attempt_submit: true, form_error: null })
		if (modal_mode === 'create')
		{
			fetch(connexion.connect.url + 'dashboard/users/insert', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					lastname: lastname,
					firstname: firstname,
					email: email,
					username: username,
					password: password,
					avatar: avatar
				})
			})
			.then(res => res.json())
			.then(ret =>
			{
				if (ret === false)
					this.setState({ attempt_submit: false, form_error: 'Une erreur s\'est produite.' })
				else if (ret === 1)
					this.setState({ attempt_submit: false, form_error: 'Un autre utilisateur avec le même identifiant existe déjà.' })
				else
				{
					this.setState({ attempt_submit: false, modal_open: false })
					this.showToast('Utilisateur créé avec succès.')
					this.loadUsers()
				}
			})
			.catch(err =>
			{
				console.log(err)
				this.setState({ attempt_submit: false, form_error: 'Une erreur s\'est produite.' })
			})
		}
		else
		{
			fetch(connexion.connect.url + 'dashboard/users/update', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					id: edit_user_id,
					lastname: lastname,
					firstname: firstname,
					email: email,
					username: username,
					password: password.length > 0 ? password : null,
					avatar: avatar
				})
			})
			.then(res => res.json())
			.then(ret =>
			{
				if (ret === false)
					this.setState({ attempt_submit: false, form_error: 'Une erreur s\'est produite.' })
				else if (ret === 1)
					this.setState({ attempt_submit: false, form_error: 'Un autre utilisateur avec le même identifiant existe déjà.' })
				else
				{
					this.setState({ attempt_submit: false, modal_open: false })
					this.showToast('Utilisateur modifié avec succès.')
					this.loadUsers()
				}
			})
			.catch(err =>
			{
				console.log(err)
				this.setState({ attempt_submit: false, form_error: 'Une erreur s\'est produite.' })
			})
		}
	}

	_renderPermissionsModal = () =>
	{
		const { modal_permissions, permissions_form, attempt_permissions, permissions_user_id } = this.state
		const currentUser = this.props.user
		const canSeeSuperAlt = currentUser && currentUser.permissions && currentUser.permissions.super % 2 === 1
		const isSelf = currentUser && String(currentUser._id) === String(permissions_user_id)
		const isEssentiel = this.props.features === 'essentiel'
		const PERMISSION_KEYS = ['homepage', 'rubrics', 'activities', 'services', 'users', 'reviews', 'stats', 'inventories', 'deposits', 'emails', 'notifications', 'params', 'precheckins', 'interventions', 'admin']
			.filter(key => !isEssentiel || (key !== 'services' && key !== 'inventories'))
		if (canSeeSuperAlt)
			PERMISSION_KEYS.push('super')
		const LABELS = {
			homepage: 'Page d\'accueil',
			rubrics: 'Rubriques',
			activities: 'Activités',
			services: 'Services',
			users: 'Utilisateurs',
			reviews: 'Avis',
			stats: 'Statistiques',
			inventories: 'Inventaires',
			deposits: 'Dépôts',
			emails: 'E-mails',
			notifications: 'Notifications',
			params: 'Paramètres',
			precheckins: 'Pré-checkins',
			interventions: 'Interventions terrain',
			admin: 'Admin',
			super: 'Super admin'
		}
		return (
			<Transition appear show={modal_permissions} as={Fragment}>
				<Dialog as="div" className="fixed z-10 inset-0 overflow-y-auto" onClose={this.closePermissionsModal}>
					<div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0"
							enterTo="opacity-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100"
							leaveTo="opacity-0"
						>
							<Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
						</Transition.Child>
						<span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 scale-95"
							enterTo="opacity-100 scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 scale-100"
							leaveTo="opacity-0 scale-95"
						>
							<div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl w-full">
								<div className="bg-white px-6 pt-6 pb-4">
									<div className="flex items-center justify-between mb-5">
										<Dialog.Title as="h3" className="text-lg font-medium text-gray-900 m-0">
											Gérer les permissions
										</Dialog.Title>
										<button
											type="button"
											onClick={this.closePermissionsModal}
											className="text-gray-400 hover:text-gray-500 focus:outline-none"
										>
											<XIcon className="h-5 w-5" />
										</button>
									</div>
									<table className="du-permissions min-w-full divide-y divide-gray-200">
										<thead className="bg-gray-50">
											<tr>
												<th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fonctionnalité</th>
												<th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" title="a = 4 (admin)">Accès</th>
												<th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" title="r = 1">Lecture</th>
												<th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" title="w = 2">Écriture</th>
												<th className="px-4 py-3 text-center text-xs font-medium text-gray-400 uppercase tracking-wider">Val.</th>
											</tr>
										</thead>
										<tbody className="bg-white divide-y divide-gray-200">
											{PERMISSION_KEYS.map(key =>
											{
												const val = permissions_form[key] != null ? permissions_form[key] : 0
												// Comme les droits Unix : lecture = 1, écriture = 2, accès = 4 (admin). La lecture est le
												// droit de base (menu, écrans) ; avoir les trois (7) sur « Inventaires » fait un administrateur des
												// inventaires (tours de terrain). La ligne « Admin » sert à administrer les utilisateurs : bits verrouillés.
												const hasAcces = (val & 4) === 4
												const hasLecture = (val & 1) === 1
												const hasEcriture = (val & 2) === 2
												const bitsLocked = key === 'admin' || key === 'super'
												const accessSelfLocked = isSelf && (key === 'admin' || key === 'super')
												const toggleBit = (bit) =>
												{
													const current = permissions_form[key] != null ? permissions_form[key] : 0
													const newVal = (current & bit) ? (current & ~bit) : (current | bit)
													if (accessSelfLocked && bit === 1 && (newVal & 1) === 0)
														return
													const updates = { [key]: newVal }
													if (bit === 1 && (newVal & 1) === 0)
														updates[key] = newVal & ~6
													if ((bit === 2 || bit === 4) && (newVal & bit) !== 0 && (newVal & 1) === 0)
														updates[key] = newVal | 1
													if (key === 'super' && bit === 1 && (newVal & 1) === 1)
														updates.admin = (permissions_form.admin != null ? permissions_form.admin : 0) | 1
													if (key === 'admin' && bit === 1 && (newVal & 1) === 0)
														updates.super = (permissions_form.super != null ? permissions_form.super : 0) & ~1
													this.setState({ permissions_form: { ...permissions_form, ...updates } })
												}
												return (
													<tr key={key}>
														<td className="px-4 py-3 text-sm font-medium text-gray-900">{LABELS[key]}</td>
														<td className="px-4 py-3 text-center">
															<input
																type="checkbox"
																checked={hasAcces}
																disabled={bitsLocked}
																onChange={() => !bitsLocked && toggleBit(4)}
																className={bitsLocked ? 'h-4 w-4 border-gray-200 rounded cursor-not-allowed opacity-30' : 'h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500'}
															/>
														</td>
														<td className="px-4 py-3 text-center">
															<input
																type="checkbox"
																checked={hasLecture}
																disabled={accessSelfLocked}
																onChange={() => toggleBit(1)}
																className={accessSelfLocked ? 'h-4 w-4 border-gray-200 rounded cursor-not-allowed opacity-30' : 'h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500'}
															/>
														</td>
														<td className="px-4 py-3 text-center">
															<input
																type="checkbox"
																checked={hasEcriture}
																disabled={bitsLocked}
																onChange={() => !bitsLocked && toggleBit(2)}
																className={bitsLocked ? 'h-4 w-4 border-gray-200 rounded cursor-not-allowed opacity-30' : 'h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500'}
															/>
														</td>
														<td className="px-4 py-3 text-center text-sm text-gray-400 font-mono">{val}</td>
													</tr>
												)
											})}
										</tbody>
									</table>
								</div>
								<div className="bg-gray-50 px-6 py-3 flex justify-end gap-3">
									<button
										type="button"
										onClick={this.closePermissionsModal}
										disabled={attempt_permissions}
										className="inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none"
									>
										Annuler
									</button>
									{attempt_permissions
										? (
											<button
												type="button"
												disabled
												className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md opacity-60 cursor-not-allowed"
											>
												<svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
													<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
													<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
												</svg>
												Enregistrement…
											</button>
										)
										: (
											<button
												type="button"
												onClick={this.submitPermissions}
												className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700 focus:outline-none"
											>
												Enregistrer
											</button>
										)
									}
								</div>
							</div>
						</Transition.Child>
					</div>
				</Dialog>
			</Transition>
		)
	}

	_renderToast = () =>
	{
		const { toast } = this.state
		if (toast === null)
			return null
		const isError = toast.type === 'error'
		return (
			<div aria-live="assertive" className="pointer-events-none fixed z-50 inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6">
				<div className="flex w-full flex-col items-center space-y-4 sm:items-end">
					<div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
						<div className="p-4">
							<div className="flex items-start">
								<div className="flex-shrink-0">
									{isError
										? <ExclamationCircleIcon className="h-6 w-6 text-red-400" aria-hidden="true" />
										: <CheckCircleIcon className="h-6 w-6 text-green-400" aria-hidden="true" />
									}
								</div>
								<div className="ml-3 w-0 flex-1 pt-0.5">
									<p className="text-sm font-medium text-gray-900">{toast.message}</p>
								</div>
								<div className="ml-4 flex flex-shrink-0">
									<button
										type="button"
										className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none"
										onClick={() => this.setState({ toast: null })}
									>
										<span className="sr-only">Fermer</span>
										<XIcon className="h-5 w-5" aria-hidden="true" />
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	_renderModal = () =>
	{
		const { modal_open, modal_mode, attempt_submit, form_error, form } = this.state
		const isEdit = modal_mode === 'edit'
		const submitLabel = attempt_submit
			? (isEdit ? 'Enregistrement…' : 'Création en cours…')
			: (isEdit ? 'Enregistrer' : 'Créer l\'utilisateur')
		const submitBtn = attempt_submit
			? (
				<button
					type="submit"
					disabled
					className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md opacity-60 cursor-not-allowed"
				>
					<svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
						<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
						<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
					</svg>
					{submitLabel}
				</button>
			)
			: (
				<button
					type="submit"
					className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-indigo-500"
				>
					{submitLabel}
				</button>
			)
		return (
			<Transition appear show={modal_open} as={Fragment}>
				<Dialog as="div" className="fixed z-10 inset-0 overflow-y-auto" onClose={this.closeModal}>
					<div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0"
							enterTo="opacity-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100"
							leaveTo="opacity-0"
						>
							<Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
						</Transition.Child>
						<span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 scale-95"
							enterTo="opacity-100 scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 scale-100"
							leaveTo="opacity-0 scale-95"
						>
							<div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg w-full">
								<form onSubmit={this.handleSubmit} className="du-form">
									<div className="bg-white px-6 pt-6 pb-4">
										<div className="flex items-center justify-between mb-5">
											<Dialog.Title as="h3" className="text-lg font-medium text-gray-900 m-0">
												{isEdit ? 'Modifier l\'utilisateur' : 'Nouvel utilisateur Dashboard'}
											</Dialog.Title>
											<button
												type="button"
												onClick={this.closeModal}
												className="text-gray-400 hover:text-gray-500 focus:outline-none"
											>
												<XIcon className="h-5 w-5" />
											</button>
										</div>
										{form_error && (
											<p className="mb-4 text-sm text-red-600">{form_error}</p>
										)}
										<div className="space-y-4">
											<div>
												<label className="block text-sm font-medium text-gray-700 mb-1">
													Avatar
												</label>
												<input
													type="file"
													accept="image/*"
													onChange={this.handleAvatar}
													className="block w-full text-sm text-gray-500 file:mr-4 file:py-1.5 file:px-3 file:rounded file:border-0 file:text-sm file:font-medium file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
												/>
												{form.avatar_preview && (
													<img
														src={form.avatar_preview}
														alt="aperçu avatar"
														className="mt-2 h-14 w-14 rounded-full object-cover"
													/>
												)}
											</div>
											<div>
												<label className="block text-sm font-medium text-gray-700 mb-1">
													Nom <span className="text-red-500">*</span>
												</label>
												<input
													type="text"
													value={form.lastname}
													onChange={this.handleField.bind(this, 'lastname')}
													className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
													placeholder="Dupont"
												/>
											</div>
											<div>
												<label className="block text-sm font-medium text-gray-700 mb-1">
													Prénom <span className="text-red-500">*</span>
												</label>
												<input
													type="text"
													value={form.firstname}
													onChange={this.handleField.bind(this, 'firstname')}
													className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
													placeholder="Jean"
												/>
											</div>
											<div>
												<label className="block text-sm font-medium text-gray-700 mb-1">
													Adresse e-mail <span className="text-red-500">*</span>
												</label>
												<input
													type="text"
													value={form.email}
													onChange={this.handleField.bind(this, 'email')}
													className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
													placeholder="jean.dupont@exemple.fr"
												/>
											</div>
											<div>
												<label className="block text-sm font-medium text-gray-700 mb-1">
													Identifiant <span className="text-red-500">*</span>
												</label>
												<input
													type="text"
													value={form.username}
													onChange={this.handleField.bind(this, 'username')}
													className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
													placeholder="jean.dupont (4 caractères min.)"
												/>
											</div>
											<div>
												<label className="block text-sm font-medium text-gray-700 mb-1">
													Mot de passe {!isEdit && <span className="text-red-500">*</span>}
												</label>
												{isEdit && (
													<p className="mb-1 text-xs text-gray-400">Laisser vide pour conserver le mot de passe actuel.</p>
												)}
												<input
													type="password"
													value={form.password}
													onChange={this.handleField.bind(this, 'password')}
													className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
													placeholder={isEdit ? '' : '8 caractères min.'}
												/>
											</div>
											<div>
												<label className="block text-sm font-medium text-gray-700 mb-1">
													Confirmation du mot de passe {!isEdit && <span className="text-red-500">*</span>}
												</label>
												<input
													type="password"
													value={form.confirm}
													onChange={this.handleField.bind(this, 'confirm')}
													className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
												/>
											</div>
										</div>
									</div>
									<div className="bg-gray-50 px-6 py-3 flex justify-end gap-3">
										<button
											type="button"
											onClick={this.closeModal}
											disabled={attempt_submit}
											className="inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-indigo-500"
										>
											Annuler
										</button>
										{submitBtn}
									</div>
								</form>
							</div>
						</Transition.Child>
					</div>
				</Dialog>
			</Transition>
		)
	}

	render()
	{
		const { users, error, modal_delete, attempt_delete } = this.state
		const currentUser = this.props.user
		const isSuper = currentUser && currentUser.permissions && currentUser.permissions.super % 2 === 1
		if (error !== null)
		{
			return (
				<div className="wrapper-content">
					<p className="error center">{error}</p>
				</div>
			)
		}
		if (users === null)
		{
			return (
				<div className="loader">
					<Loader />
				</div>
			)
		}
		return (
			<div className="wrapper-content">
				{this._renderToast()}
				{this._renderPermissionsModal()}
				<ModalDelete
					title="Supprimer l'utilisateur"
					content="Vous allez supprimer cet utilisateur définitivement"
					attempt_submit={attempt_delete}
					open_modal={modal_delete}
					answerModal={this.answerModalDelete}
				/>
				{this._renderModal()}
				{/* Breadcrumb */}
				<div className="mb-5">
					<ol className="flex items-center gap-1 text-sm">
						<li className="flex items-center">
							<Link to="/" className="text-gray-400 hover:text-gray-600 transition-colors">
								<HomeIcon className="flex-shrink-0 h-4 w-4" aria-hidden="true" />
								<span className="sr-only">Accueil</span>
							</Link>
						</li>
						<li className="flex items-center">
							<span className="text-gray-300 mx-1 select-none">/</span>
							<Link to="/administration/parametres" className="text-gray-400 hover:text-gray-600 transition-colors">Paramètres</Link>
						</li>
						<li className="flex items-center">
							<span className="text-gray-300 mx-1 select-none">/</span>
							<span className="text-gray-400">Équipe &amp; accès</span>
						</li>
					</ol>
				</div>
				{/* Page header */}
				<div className="flex items-end justify-between mb-8">
					<div>
						<h1
							style={{ fontFamily: "'Fraunces', Georgia, serif", letterSpacing: '-0.02em', margin: 0 }}
							className="text-4xl font-bold text-gray-900 leading-none"
						>
							Équipe & accès
						</h1>
						<p className="text-sm text-gray-400" style={{ margin: '0.5rem 0 0' }}>
							Gérez les accès au tableau de bord
						</p>
					</div>
					<button
						type="button"
						onClick={this.openCreateModal}
						style={{ backgroundImage: 'none', backgroundColor: '#4f46e5' }}
						className="inline-flex items-center px-4 py-2 shadow-sm text-sm font-medium rounded-md text-white"
					>
						<UserAddIcon className="-ml-1 mr-2 h-5 w-5" aria-hidden="true" />
						Créer un utilisateur
					</button>
				</div>
				<div className="flex flex-col">
					<div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
						<div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
							<div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
								<table className="min-w-full divide-y divide-gray-200">
									<thead className="bg-gray-50">
										<tr>
											<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Avatar</th>
											<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nom</th>
											<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
											<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Identifiant</th>
											<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Création</th>
											<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Équipe</th>
											<th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6"><span className="sr-only">Permissions</span></th>
											<th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6"><span className="sr-only">Éditer</span></th>
											<th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6"><span className="sr-only">Supprimer</span></th>
										</tr>
									</thead>
									<tbody className="bg-white divide-y divide-gray-200">
										{users.filter(user => isSuper || !(user.permissions && user.permissions.super % 2 === 1)).map(user =>
										{
											const avatarJSX = user.avatar
												? <img src={user.avatar} alt="avatar" className="h-8 w-8 rounded-full object-cover" />
												: (
													<span className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-gray-200">
														<svg className="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
															<path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
														</svg>
													</span>
												)
											return (
												<tr key={user._id}>
													<td className="px-6 py-4 whitespace-nowrap">{avatarJSX}</td>
													<td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{user.firstname} {user.lastname}</td>
													<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{user.email}</td>
													<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{user.username}</td>
													<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{parseDate(user.created_time)}</td>
													<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
														{this.state.editing_team === user._id
															? (
																<select
																	autoFocus
																	className="du-team-select"
																	defaultValue={user.team != null ? user.team : ''}
																	onChange={e => this.updateTeam(user._id, e.target.value)}
																	onBlur={() => this.setState({ editing_team: null })}
																>
																	<option value="">—</option>
																	<option value="Ménage">Ménage</option>
																	<option value="Technique">Technique</option>
																	<option value="Réception">Réception</option>
																	<option value="Animation">Animation</option>
																	<option value="Direction">Direction</option>
																	<option value="Restauration">Restauration</option>
																</select>
															)
															: (
																<span className="flex items-center gap-1.5">
																	<span>{user.team != null ? user.team : '—'}</span>
																	<button
																		onClick={() => this.setState({ editing_team: user._id })}
																		className="text-gray-400 hover:text-gray-600"
																		title="Modifier l'équipe"
																	>
																		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-3.5 h-3.5">
																			<path d="M2.695 14.763l-1.262 3.154a.5.5 0 00.65.65l3.155-1.262a4 4 0 001.343-.885L17.5 5.5a2.121 2.121 0 00-3-3L3.58 13.42a4 4 0 00-.885 1.343z" />
																		</svg>
																	</button>
																	{user.team != null && (
																		<button
																			onClick={() => this.updateTeam(user._id, '')}
																			className="text-gray-300 hover:text-red-400"
																			title="Réinitialiser l'équipe"
																		>
																			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-3.5 h-3.5">
																				<path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
																			</svg>
																		</button>
																	)}
																</span>
															)
														}
													</td>
													<td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
														<button onClick={this.openPermissionsModal.bind(this, user)} className="text-indigo-400 hover:text-indigo-700">
															Permissions<span className="sr-only">, {user.firstname} {user.lastname}</span>
														</button>
													</td>
													<td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
														<button onClick={this.openEditModal.bind(this, user)} className="text-indigo-600 hover:text-indigo-900">
															Éditer<span className="sr-only">, {user.firstname} {user.lastname}</span>
														</button>
													</td>
													<td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
														<button onClick={this.openDeleteModal.bind(this, user._id)} className="text-red-300 hover:text-red-600">
															<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
																<path fillRule="evenodd" d="M16.5 4.478v.227a48.816 48.816 0 013.878.512.75.75 0 11-.256 1.478l-.209-.035-1.005 13.07a3 3 0 01-2.991 2.77H8.084a3 3 0 01-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 01-.256-1.478A48.567 48.567 0 017.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 013.369 0c1.603.051 2.815 1.387 2.815 2.951zm-6.136-1.452a51.196 51.196 0 013.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 00-6 0v-.113c0-.794.609-1.428 1.364-1.452zm-.355 5.945a.75.75 0 10-1.5.058l.347 9a.75.75 0 101.499-.058l-.346-9zm5.48.058a.75.75 0 10-1.498-.058l-.347 9a.75.75 0 001.5.058l.345-9z" clipRule="evenodd" />
															</svg>
															<span className="sr-only">Supprimer, {user.firstname} {user.lastname}</span>
														</button>
													</td>
												</tr>
											)
										})}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default DashboardUsers
